import {AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild} from "@angular/core";
import {ActivatedRoute, NavigationExtras, Router} from "@angular/router";
import {NgbModal, NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";
import {SetPatientAction, SetTestOrderDetails} from "../../actions";
import {AuthService, PatientService, UtilService} from "../../services";
import {Store} from "@ngrx/store";
import {Patient, TestOrder} from "../../models";
import {StateService} from "../../services/state/state.service";
import {StateModel} from "../../models/state.model";
import {Location} from "@angular/common";
import {Subscription} from "rxjs/Subscription";
import {RegexPattern} from "../../models/regex.pattern";

@Component({
  selector: "app-new-patient-additional-details-modal",
  templateUrl: "./patient-additional-details-modal.component.html",
  styleUrls: ["./patient-additional-details-modal.component.scss"]
})
export class PatientAdditionalDetailsNewModalComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("content") template: TemplateRef<any>;

  public redirect: string;

  public years: Array<number> = [];
  public states: Array<StateModel> = [];
  public modalRef: any;
  public patient: Patient;
  public regexModel: RegexPattern;
  public confirm: boolean = false;
  public requestPending: boolean = false;
  public editMode: boolean = false;
  public modalTitle = "Add Patient Info";
  public showPatientExistsError = false;
  public isOfficeStaff: boolean;
  public nextButtonText = "NEXT";
  public verifyEmail: string;

  private subscriptions: { [name: string]: Subscription } = {};

  private modalOptions: NgbModalOptions = {
    backdrop: "static",
    windowClass: "patient-details",
    container: "app-new-patient-additional-details-modal",
    keyboard: false
  };

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private modalService: NgbModal,
    private utilService: UtilService,
    private stateService: StateService,
    private store: Store<any>,
    private patientService: PatientService,
    private authService: AuthService,
    private location: Location
  ) {
    this.regexModel = new RegexPattern()
  }

  ngOnInit() {
    this.subscriptions["state"] = this.stateService.get().subscribe(value => {
      this.states = value;
    });

    this.subscriptions["route"] = this.route.queryParams.subscribe(params => {
      this.redirect = params["redirect"] || "";
    });
    this.subscriptions["patient"] = this.store
      .select("patient")
      .subscribe(patient => {
        this.patient = Object.assign({}, new Patient(), patient);
      });
    this.isOfficeStaff = false; // this.authService.getUser().Role === "staff";
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.modalRef = this.modalService.open(this.template, this.modalOptions);
    });
  }

  get isButtonEnabled() {
    return true;
  }

  ngOnDestroy() {
    setTimeout(() => {
      this.modalRef.close();
    });
    for (let sub in this.subscriptions) {
      if (this.subscriptions.hasOwnProperty(sub)) {
        this.subscriptions[sub].unsubscribe();
      }
    }
  }

  canSkip() {
    return false;
  }

  stateSelected(value: string) {
    if (value === "none") {
      this.patient.Address.State = "";
    }
  }

  back() {
    this.store.dispatch(new SetPatientAction(this.patient, this.utilService));
    this.location.back();
  }

  update() {

  this.store.dispatch(new SetPatientAction(this.patient, this.utilService));
  let navigationExtras: NavigationExtras = {
    queryParams: {redirect: this.redirect}
  };
  this.router.navigate(["/home/create/billing"], navigationExtras);

  }

  checkFormValidity(form) {
    let detectNonAlphaRegex = /[^a-zA-Z]/g;
    return form.invalid || detectNonAlphaRegex.test(this.patient.MiddleName) || this.patient.State === ""
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/patient-additional-details-modal/patient-additional-details-new-modal.component.ts